import React from 'react'

function CustomerSharingFeatureBox1() {
    return (
        <div className='homebox2main' id='feature-box1'>
            <div className='container'>
                <div className='homebox2'>
                    <div className='homebox2-left'>
                        <img src="/img-engage.webp" alt="hero-img" />
                    </div>
                    <div className='homebox2-right'>
                        <span>Customer Sharing & Enrollment</span>
                        <h2>Make Customer Onboarding Effortless</h2>
                        <p>Create a smooth and engaging enrollment experience that allows customers to quickly join your loyalty or membership program. Enable easy sharing options to help grow your customer base through referrals, digital invites, and seamless sign-ups.</p>
                        <h5>Features Designed for Better Engagement</h5>
                        <ul>
                            <li>Simplify customer enrollment with a fast and user-friendly process</li>
                            <li>Allow easy sharing of membership cards, rewards, and referral links</li>
                            <li>Capture customer information securely during registration</li>
                            <li>Increase brand visibility through customer-to-customer sharing</li>
                            <li>Improve engagement and retention with a connected onboarding experience</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CustomerSharingFeatureBox1